import { useCallback, useState } from "react";
import { Seo } from "../components/layout/Seo";
import { BootSequence } from "../components/layout/BootSequence";
import { Hero } from "../components/home/Hero";
import { Intro } from "../components/home/Intro";
import { Marquee } from "../components/home/Marquee";
import { ServicesBento } from "../components/home/ServicesBento";
import { Industries } from "../components/home/Industries";
import { OurName } from "../components/home/OurName";
import { Approach } from "../components/home/Approach";
import { BrendanTeaser } from "../components/home/BrendanTeaser";
import { ShopTeaser } from "../components/home/ShopTeaser";
import { Vision } from "../components/home/Vision";
import { ContactSection } from "../components/home/ContactSection";

export default function Home() {
  const [ready, setReady] = useState(false);
  const done = useCallback(() => setReady(true), []);
  return (
    <>
      <Seo title="TechCare Technologies — Technology That Cares | Kenya"
        description="Kenyan technology company delivering field services, digital infrastructure, AI, software engineering, managed IT, cybersecurity and drone technology." />
      <BootSequence onDone={done} />
      <Hero ready={ready} />
      <Intro />
      <Marquee />
      <ServicesBento />
      <Industries />
      <OurName />
      <Approach />
      <BrendanTeaser />
      <ShopTeaser />
      <Vision />
      <ContactSection />
    </>
  );
}
